import { createSelector } from '@reduxjs/toolkit';
import { State } from 'store';

export const getLandingState = (state: State) => state.landing;

export const getBaner = createSelector(
  getLandingState,
  (landing) => landing.baner
);
export const getDescription = createSelector(
  getLandingState,
  (landing) => landing.description
);
export const getSubtitle = createSelector(
  getLandingState,
  (landing) => landing.subtitle
);
export const getTitle = createSelector(
  getLandingState,
  (landing) => landing.title
);
export const isLoading = createSelector(
  getLandingState,
  (landing) => landing.isLoading || landing.areProductsFetching
);
export const getFeaturedProducts = createSelector(
  getLandingState,
  (landing) => {
    return [...landing.featuredProducts].sort((a, b) =>
      a.position > b.position ? 1 : -1
    );
  }
);
export const getLandingSettings = createSelector(
  getLandingState,
  (landing) => ({
    title: landing.title,
    subtitle: landing.subtitle,
    description: landing.description,
  })
);
